import React, { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ChatProvider } from './context/ChatContext';
import { LoginPage, RegisterPage } from './components/Auth/AuthPages';
import ChatPage from './pages/ChatPage';
import PartnersAdminPage from './pages/admin/PartnersAdmin';
import './index.css';

// Lightweight path-aware routing — keeps the existing single-page feel
// without adding react-router. Two known paths: /admin/partners, and
// everything else (the chat app).
function useLocationPath() {
  const [path, setPath] = useState(window.location.pathname);
  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);
  return path;
}

function AppContent() {
  const { user, loading } = useAuth();
  const [showRegister, setShowRegister] = useState(false);
  const path = useLocationPath();

  if (loading) {
    return (
      <div className="loading-screen">
        <img
          src="/img/noris-logo.svg"
          alt="Noris"
          className="logo"
          onError={e => { e.target.style.display = 'none'; }}
        />
        <div className="spinner" style={{ borderColor: 'rgba(255,255,255,.3)', borderTopColor: 'white' }} />
        <p>Loading NChat...</p>
      </div>
    );
  }

  if (!user) {
    return showRegister
      ? <RegisterPage onSwitch={() => setShowRegister(false)} />
      : <LoginPage onSwitch={() => setShowRegister(true)} />;
  }

  // Admin-only: partners panel
  if (path.startsWith('/admin/partners')) {
    return <PartnersAdminPage />;
  }

  return (
    <ChatProvider>
      <ChatPage />
    </ChatProvider>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
